import Vue from 'vue'
import App from './App.vue'
import AppPos from './AppPos.vue'
import router from './router/web'
import posRouter from './router/pos';
import store from './store'
import BootstrapVue from "bootstrap-vue"
import axios from 'axios';

Vue.use(BootstrapVue);
Vue.config.productionTip = false;
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const host = window.location.host;
const parts = host.split('.');
const domainLength = 3; // route1.example.com => domain length = 3

function checkRouter() {
  let routes;
  let usingApp;
  if (parts.length === (domainLength - 1) || parts[0] === 'www') {
    routes = router;
    usingApp = App;
  } else if (parts[0].indexOf('pos') !== -1) {
    routes = posRouter;
    usingApp = AppPos;
  } else {
    routes = router;
    usingApp = App;
  }
  return [routes, usingApp];
}

const [routerAll, usingApp] = checkRouter();
// const routerAll = () => {
//   let routes;
//   if (parts.length === (domainLength - 1) || parts[0] === 'www') {
//     routes = router;
//   } else if (parts[0] === 'pos') {
//     routes = posRouter;
//   } else {
//     routes = router;
//   }
//   return routes;
// };

new Vue({
  router: routerAll,
  store,
  render: h => h(usingApp)
}).$mount('#app')
